import * as actions from './actions';
import reducer from './reducers';
import * as selectors from './selectors';
import * as shapes from './shapes';
import NAMESPACE from './types';

export {
    actions,
    selectors,
    shapes,
};

export default {
    [NAMESPACE]: reducer,
};
